var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWorkspaceInstanceScroll = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  stroke: "#707070",
  fill: "#FFF",
  fillRule: "nonzero",
  x: 2.5,
  y: 2.5,
  width: 15,
  height: 15,
  rx: 1
}), /*#__PURE__*/React.createElement("path", {
  fill: "#AA2FF0",
  d: "m5.385 10 7.384-4.615v9.23z"
}))));
export default SvgWorkspaceInstanceScroll;